<template>
  <v-app>
    <v-app-bar app fixed dense dark>
      <div class="d-flex align-center">
        <img style="height:38px; margin-right:14px;" src="./assets/logo.svg" />
        <v-toolbar-title style="display:flex;align-items:center;"><b>Virtus</b><span style="font-size:10pt;margin-left:7px">- Algoritmo de sobrevivência empresarial.</span></v-toolbar-title>
      </div>
    </v-app-bar>

    <v-content style="background-color:#e6e6e6;">
      <router-view />
    </v-content>
    <v-footer dark style="font-size:10pt;">
      <div>
       Concepted by <b><a target="blank" href="https://www.linkedin.com/in/renatof/"
          style="color:#fff;text-decoration:none;">@Renato Fonseca</a></b>&nbsp;&amp; developed by&nbsp;
        <b><a target="blank" href="https://linkedin.com/in/pedrobaesso/" style="color:#fff;text-decoration:none;">
          @Pedro Baesso</a></b>.
      </div>
      <v-spacer />
      <h5>v1.0.0</h5>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    name: 'App'
  };
</script>